// extracted by mini-css-extract-plugin
export default {"contact_container":"Contact_contact_container__QNG4i","contact_content":"Contact_contact_content__fienU","footer_text":"Contact_footer_text__aivfV"};